import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-service-reg-view-form',
  templateUrl: './service-reg-view-form.component.html',
  styleUrls: ['./service-reg-view-form.component.css']
})
export class ServiceRegViewFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/serviceregister/service-register-views/service-reg-view-form/service-reg-view-form.component.ts